import { render, staticRenderFns } from "./KomIndenfor.vue?vue&type=template&id=52d2232a&scoped=true&"
import script from "./KomIndenfor.vue?vue&type=script&lang=js&"
export * from "./KomIndenfor.vue?vue&type=script&lang=js&"
import style0 from "./KomIndenfor.vue?vue&type=style&index=0&id=52d2232a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2232a",
  null
  
)

export default component.exports